(function () {
  var TARGET_FOV = '45deg';
  var TARGET_ORBIT = '45deg 75deg auto';
  var TARGET_CAMERA = '0m 0m 0m';

  function lockModelViewer(mv) {
    mv.setAttribute('camera-target', TARGET_CAMERA);
    mv.setAttribute('camera-orbit', TARGET_ORBIT);
    mv.setAttribute('field-of-view', TARGET_FOV);
    mv.setAttribute('min-field-of-view', TARGET_FOV);
    mv.setAttribute('max-field-of-view', TARGET_FOV);
    mv.setAttribute('disable-zoom', '');
    mv.setAttribute('disable-pan', '');
    mv.setAttribute('interaction-prompt', 'none');
  }

  function watchModelViewer(mv) {
    // Apply immediately
    lockModelViewer(mv);

    // Watch for Shopify's product-model.js resetting field-of-view
    var attrObserver = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'field-of-view') {
          var cur = mv.getAttribute('field-of-view');
          if (cur !== TARGET_FOV) {
            mv.setAttribute('field-of-view', TARGET_FOV);
            mv.setAttribute('min-field-of-view', TARGET_FOV);
            mv.setAttribute('max-field-of-view', TARGET_FOV);
          }
        }
        if (m.attributeName === 'camera-orbit') {
          var cur = mv.getAttribute('camera-orbit');
          if (cur !== TARGET_ORBIT) {
            mv.setAttribute('camera-orbit', TARGET_ORBIT);
          }
        }
      });
    });
    attrObserver.observe(mv, { attributes: true, attributeFilter: ['field-of-view', 'camera-orbit'] });
  }

  function loadModel(container) {
    var model = container.querySelector('product-model');
    if (!model || model.dataset.loaded) return;
    model.dataset.loaded = 'true';
    customElements.whenDefined('product-model').then(function () {
      if (typeof model.loadContent === 'function') {
        model.loadContent();
        // Watch for model-viewer to appear, then lock it
        var childObs = new MutationObserver(function() {
          var mv = model.querySelector('model-viewer');
          if (mv) {
            childObs.disconnect();
            watchModelViewer(mv);
          }
        });
        childObs.observe(model, { childList: true, subtree: true });
        // Also check immediately in case it's already there
        var mv = model.querySelector('model-viewer');
        if (mv) watchModelViewer(mv);
      }
    });
  }

  function checkSlide(slide) {
    if (!slide) return;
    var container = slide.querySelector('.media-type-model');
    if (container) loadModel(container);
  }

  function init() {
    document.querySelectorAll('.product__media-list').forEach(function(list) {
      checkSlide(list.querySelector('.slider__slide.is-active'));
      new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'class' && m.target.classList.contains('is-active'))
            checkSlide(m.target);
        });
      }).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
